import Base from './base';

class Basket extends Base {
    getAll = () => this.getRequest('/basket')
}

export default new Basket();
